// 26 §1.2: /login/link#t=<token_hash>&r=<return> — קישור כניסה חד-פעמי. ה-token ב-fragment (לא מגיע לשרת/ללוגים/ל-referrer);
// הדף קורא אותו, מוחק את ה-fragment מההיסטוריה מיד, מאמת מול GoTrue (verify magiclink) ושומר את הסשן בדיוק כמו /login.
// הצלחה → r (יחסי בלבד, safeReturn); כישלון → /login?reason=link_expired&return=r. כניסה קיימת בדפדפן מוחלפת.
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { loginWithLink } from '../lib/auth.ts';
import { safeReturn } from '../lib/safeReturn.ts';
import { T } from '../lib/strings.ts';
import { Logo } from '../components/brand/Logo.tsx';

/** t ו-r מתוך ה-fragment (#t=…&r=…). */
export function parseLinkFragment(hash: string): { t: string | null; r: string } {
  const p = new URLSearchParams(hash.replace(/^#/, ''));
  return { t: p.get('t') || null, r: safeReturn(p.get('r') || '/') };
}

export function LoginLinkPage() {
  const nav = useNavigate();
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return; // StrictMode: אימות אחד בלבד (ה-token חד-פעמי)
    started.current = true;
    const { t, r } = parseLinkFragment(window.location.hash);
    // ה-fragment לא נשאר בהיסטוריה (חזרה אחורה / שיתוף מסך / היסטוריית הדפדפן)
    window.history.replaceState(window.history.state, '', window.location.pathname);
    const fail = () => nav(`/login?reason=link_expired&return=${encodeURIComponent(r)}`, { replace: true });
    if (!t) {
      void fail();
      return;
    }
    void loginWithLink(t).then((ok) => (ok ? nav(r, { replace: true }) : fail()));
  }, [nav]);

  return (
    <main className="grid min-h-(--ab-screen) place-items-center bg-background px-4 text-foreground">
      <div className="flex flex-col items-center gap-6" role="status" aria-live="polite" data-testid="login-link">
        <Logo className="h-10" />
        <p className="m-0 text-base text-muted-foreground">{T.login.linkBusy}</p>
      </div>
    </main>
  );
}
